import { render, staticRenderFns } from "./newDetail.vue?vue&type=template&id=691515aa&scoped=true"
import script from "./newDetail.vue?vue&type=script&lang=js"
export * from "./newDetail.vue?vue&type=script&lang=js"
import style0 from "./newDetail.vue?vue&type=style&index=0&id=691515aa&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "691515aa",
  null
  
)

export default component.exports